export default {
// ko-KR.js
help: {
  faq: "자주 묻는 질문",
  promo: "프로모션",
  contactUs: "문의하기",
  joinCommunity: "커뮤니티 참여하기",
  help: "도움말"
}
};
